export default "__VITE_ASSET__BjSO2TM9__"